import { Identifiable, ProjectResource, ResourceTypes } from "@planzone/dto";
import { Sorters, SortFunctions } from "./types";

function sortResourceList(
  resourceList: Identifiable<ProjectResource>[],
  activeSorter: Sorters,
) {
  const sortFunctions: SortFunctions = {
    [Sorters.None]: (list) =>
      [...list]
        .sort((a, b) => a.resource.name.localeCompare(b.resource.name))
        .sort((a, b) => {
          const priority = {
            [ResourceTypes.HUMAN]: 1,
            [ResourceTypes.VIRTUAL]: 2,
            [ResourceTypes.MATERIAL]: 3,
          };

          return priority[a.resource.type] - priority[b.resource.type];
        }),
    [Sorters.Name]: (list) =>
      [...list].sort((resourceA, resourceB) => {
        return resourceA.resource.name.localeCompare(resourceB.resource.name);
      }),
    [Sorters.Role]: (list) =>
      [...list].sort((resourceA, resourceB) =>
        resourceA.resource.type === ResourceTypes.MATERIAL
          ? 1
          : resourceB.resource.type === ResourceTypes.MATERIAL
            ? -1
            : resourceA.role.name.localeCompare(resourceB.role.name),
      ),
    [Sorters.EntryDate]: (list) =>
      [...list].sort((resourceA, resourceB) => {
        const dateA = new Date(resourceA.resource.createdDate);
        const dateB = new Date(resourceB.resource.createdDate);
        return dateA > dateB ? 1 : dateA < dateB ? -1 : 0;
      }),
  };

  return sortFunctions[activeSorter](resourceList);
}

export { sortResourceList };
